import {Component, Input, OnInit} from '@angular/core';
import {SubjectApiService, SubjectCategoryItem} from '@npck/af-frontend-api';
import {rxSpinner} from '@npck/libs/commons';
import {initialPageEvent, mergeTableEvent, TableEvent} from '../../../../components/full-table/full-table.component';
import {PageEvent} from '../../../../components/full-table/paging/paginator.component';
import {Column, ColumnType, Row, StatusColumn} from '../../../../components/full-table/table/table.component';
import {StatusStyle} from '../../../../components/status/status.component';

const DEFAULT_SORT_BY = 'created_date';
const DEFAULT_SORT_ORDER = 'DESC';
const SPINNER_ID = 'categories';

@Component({
    selector: 'af-subject-categories-tab',
    standalone: false,
    templateUrl: './subject-categories-tab.component.html',
})
export class SubjectCategoriesTabComponent implements OnInit {
    @Input() subjectId: string;
    dataSource: Row[] = [];
    totalElements = 0;
    pageEvent: PageEvent = initialPageEvent;
    columnTranslationPrefixes = {
        created_by: 'subjectCategory',
        updated_by: 'subjectCategory',
        deleted_by: 'subjectCategory',
    };

    private tableEvent: TableEvent = {page: initialPageEvent, spinnerId: SPINNER_ID};

    constructor(private subjectApiService: SubjectApiService) {
    }

    ngOnInit(): void {
        this.loadPage(this.tableEvent);
    }

    loadPage(tableEvent: TableEvent): void {
        this.tableEvent = mergeTableEvent(this.tableEvent, tableEvent);
        this.pageEvent = this.tableEvent.page!;
        this.subjectApiService.getSubjectCategories({
            id: this.subjectId,
            shouldHideVictim: false,
            sortBy: this.tableEvent.sortBy?.columnName ?? DEFAULT_SORT_BY,
            sortOrder: this.tableEvent.sortBy?.direction ?? DEFAULT_SORT_ORDER,
            limit: this.pageEvent.pageSize,
            offset: this.pageEvent.pageOffset,
        })
            .pipe(rxSpinner(SPINNER_ID))
            .subscribe(response => {
                this.dataSource = response.items.map(item => this.toRow(item));
                this.totalElements = response.total ?? 0;
            });
    }

    private toRow(item: SubjectCategoryItem): Row {
        return {
            is_deleted_category: <StatusColumn>{
                type: ColumnType.STATUS,
                sortable: true,
                text: item.isDeleted ? 'i18n_af_statusDeleted' : 'i18n_af_statusActive',
                style: item.isDeleted ? StatusStyle.ERROR : StatusStyle.SUCCESS,
            },
            categories: <Column>{
                type: ColumnType.TEXT,
                text: item.category ? `i18n_af_category#${item.category}` : '-',
            },
            created_date: <Column>{
                type: ColumnType.DATE_TIME_SECONDS,
                sortable: true,
                text: item.createdDate,
            },
            updated_date: <Column>{
                type: ColumnType.DATE_TIME_SECONDS,
                sortable: true,
                text: item.updatedDate,
            },
            deleted_date: <Column>{
                type: ColumnType.DATE_TIME_SECONDS,
                sortable: true,
                text: item.deletedDate,
            },
            created_by: <Column>{
                type: ColumnType.TEXT,
                text: item.createdBy ?? '-',
            },
            updated_by: <Column>{
                type: ColumnType.TEXT,
                text: item.updatedBy ?? '-',
            },
            deleted_by: <Column>{
                type: ColumnType.TEXT,
                text: item.deletedBy ?? '-',
            },
        };
    }
}
